module.exports = __webpack_public_path__ + "img/formMarketBanner.1d288f6e.png";